"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function MagneticWrapper({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const {
      clientX,
      clientY
    } = e;
    if (!ref.current) return;
    const {
      height,
      width,
      left,
      top
    } = ref.current.getBoundingClientRect();
    const middleX = clientX - (left + width / 2);
    const middleY = clientY - (top + height / 2);
    setPosition({
      x: middleX * 0.2,
      y: middleY * 0.2
    });
  };
  const handleMouseLeave = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  return <div data-section-id="18601" ref={ref} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className={className} style={{
    transform: `translate(${position.x}px, ${position.y}px)`,
    transition: "transform 0.1s ease-out"
  }}>
      {children}
    </div>;
}
export default function Hero() {
  const [bgLoaded, setBgLoaded] = useState(false);
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  useEffect(() => {
    const timer = setTimeout(() => setBgLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return <section id="volunteer-invitation-hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[hsl(222,47%,11%)]">
      {}
      <div className={`absolute inset-0 z-0 transition-opacity duration-1000 ease-out ${bgLoaded ? "opacity-100" : "opacity-0"}`}>
        {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590036/img/abstract_vault_node_render.png" alt="Compassionate community gathering and senior support" className="w-full h-full object-cover object-center opacity-60 mix-blend-overlay" />
        
        {}
        <div className="absolute inset-0 bg-[hsl(222,47%,11%)]/50 pointer-events-none" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <h1 className="text-white font-serif font-semibold text-4xl md:text-6xl lg:text-[72px] leading-[1.1] tracking-tight max-w-4xl mx-auto drop-shadow-xl">
            Join the Network of Compassion
          </h1>

          {}
          <p className="text-white/80 text-lg md:text-[22px] font-sans font-medium mt-6 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
            Share your time and faith to ensure no senior in our community has to face their final years alone or in isolation.
          </p>

          {}
          <div className="mt-10 flex justify-center">
            <MagneticWrapper className="inline-block">
              <Button asChild className="bg-[hsl(43,74%,49%)] text-[hsl(222,47%,11%)] hover:bg-[hsl(43,74%,49%)]/90 rounded-xl px-8 py-6 text-lg font-bold shadow-[0_0_25px_rgba(212,163,6,0.3)] hover:shadow-[0_0_35px_rgba(212,163,6,0.5)] transition-all duration-300 border-none">
                <Link to="/VolunteerSignUpPage">
                  Start Your Application
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </MagneticWrapper>
          </div>
        </div>
      </div>
    </section>;
}